import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const API = `${BACKEND_URL}/api`;
const siteRequests = new Map();
if(document.documentElement.dataset.showroomPreview)axios.defaults.headers.common["X-Showroom-Preview"]="1";
function siteContent(key) {
  const previous = siteRequests.get(key);
  if (previous && previous.until > Date.now()) return previous.promise;
  const promise = axios.get(`${API}/site/${key}`).then((r) => r.data).catch((error) => {
    siteRequests.delete(key);
    throw error;
  });
  siteRequests.set(key, { promise, until: Date.now() + 30000 });
  return promise;
}

export const api = {
  products: (params = {}) => axios.get(`${API}/products`, { params }).then((r) => r.data),
  product: (slug) => axios.get(`${API}/products/${slug}`).then((r) => r.data),
  related: (slug) => axios.get(`${API}/products/${slug}/related`).then((r) => r.data),
  collections: () => axios.get(`${API}/collections`).then((r) => r.data),
  collection: (slug) => axios.get(`${API}/collections/${slug}`).then((r) => r.data),
  spaces: () => axios.get(`${API}/spaces`).then((r) => r.data),
  filters: () => axios.get(`${API}/filters`).then((r) => r.data),
  createEnquiry: (payload) => axios.post(`${API}/enquiries`, payload).then((r) => r.data),
  events: () => axios.get(`${API}/events`).then((r) => r.data),
  eventSlots: (id, date) => axios.get(`${API}/events/${encodeURIComponent(id)}/slots`, { params: { date } }).then((r) => r.data),
  subscribe: (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data),
  contact: (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data),
  site: siteContent,
};
